import styled from 'styled-components';
import { H3 } from 'components/typography';

export const ImagePreview = styled.img`
  max-height: 320px;
  max-width: 320px;
  width: auto;
  height: auto;
`;

export const FileName = styled(H3)`
  display: flex;
  justify-content: center;
`;
